import React from "react";

const ImportIcon = props => (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" width={props.width ? props.width : '24'}
         height={props.height ? props.height : '24'} viewBox="0 0 24 24" fill="none"
         stroke={props.stroke ? props.stroke : 'currentColor'}
         strokeWidth={props.strokeWidth ? props.strokeWidth : 2} strokeLinecap="round" strokeLinejoin="round"
    >
        <path d="M12 3v12"/>
        <path d="m8 11 4 4 4-4"/>
        <path d="M8 5H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-4"/>
    </svg>
);

export default ImportIcon;


// WEBPACK FOOTER //
// ./src/assets/icons/ImportIcon.jsx